import { render, staticRenderFns } from "./chatDetails.vue?vue&type=template&id=e1f2c8ce&"
import script from "./chatDetails.vue?vue&type=script&lang=js&"
export * from "./chatDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports